import { Injectable } from "@angular/core";
import { AngularFire } from "angularfire2";
import moment from "moment";

@Injectable()
export class UserService {
  public static readonly TYPE_STUDENT = "student";
  public static readonly TYPE_WHANAU_FRIEND = "whanau-friend";

  constructor(public af: AngularFire) {}

  // Auth helpers
  loginUser(email: string, password: string) {
    return this.af.auth
      .login({
        email: email,
        password: password,
      })
      .then((authUser: any) => {
        return this.getAuthUserById(authUser.uid);
      })
      .then((authUser: any) => {
        authUser.sessionExpired = false;
        authUser.lastLogin = moment()
          .unix()
          .toString();

        return this.updateAuthUser(authUser);
      });
  }

  logoutUser() {
    return this.af.auth.logout();
  }

  // CRUD
  updateAuthUser(authUser: any) {
    if (!authUser || !authUser.uid) {
      return Promise.reject(new Error("No UID found for Auth user"));
    }

    return this.af.database
      .object(`authorized/${authUser.uid}`)
      .update(authUser)
      .then(() => authUser);
  }

  // Validators
  validateEmail(email: string) {
    return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      email.toLowerCase(),
    );
  }

  // Getters and setters
  getUserSafeContacts(userId: string): Promise<any> {
    return new Promise((resolve, reject) => {
      return this.getUserById(userId)
        .then((user: any) => {
          if (!user) {
            return resolve([]);
          }

          this.af.database
            .list(`contacts/${user.id}`)
            .$ref.once("value")
            .then(contacts => {
              if (!contacts) {
                return resolve([]);
              }

              resolve(contacts.val());
            });
        })
        .catch(error => reject(error));
    });
  }

  getAuthUserById(userId): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!userId) {
        return reject(new Error("No user ID provided."));
      }

      this.af.database
        .object(`authorized/${userId}`)
        .$ref.once("value")
        .then(data => {
          let user = data.val();
          if (!user) {
            return reject(new Error("Not an authorized user."));
          }

          return resolve(user);
        });
    });
  }

  getUserById(userId): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!userId) {
        return reject(new Error("No user ID provided."));
      }

      this.af.database
        .object(`users/${userId}`)
        .$ref.once("value")
        .then(data => {
          let user = data.val();
          if (!user) {
            return resolve(null);
          }

          return resolve(user);
        });
    });
  }

  static get userTypeStudent() {
    return UserService.TYPE_STUDENT;
  }

  static get userTypeWhanauFriend() {
    return UserService.TYPE_WHANAU_FRIEND;
  }
}



// WEBPACK FOOTER //
// ./src/providers/user.ts